<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between aling-items-center">
    <a class="nav-item fw-bold brand" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">{{ 'nav.go.to.home.page' | translate }}</label>
      <img alt="" class="home-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
    </a>

    <div class="d-flex right-mobile-nav align-items-center justify-content-end">
      <!-- Notification Button -->
      <fgb-notification-button></fgb-notification-button>

      <button class="nav-item fw-bold navbar-toggler m-0" (click)="isCollapsed = !isCollapsed">
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown bg-primary">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <div class="mobile-menu-header d-flex flex-row align-items-center justify-content-between">
        <!--Logo-->
        <img alt="" class="card-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
        <!-- Close Button -->
        <button
          class="close-button position-absolute border-0"
          attr.aria-label="{{ 'modal.close' | translate }}"
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="button-icon material-icons">close</span>
        </button>
      </div>

      <div class="card-member">
        <ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
          <fgb-barcode [showFooter]="false"></fgb-barcode>
        </ng-container>

        <ng-template #loadingRef>
          <fgbcl-loading></fgbcl-loading>
        </ng-template>
      </div>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container container">
        <a class="nav-item" [routerLink]="['/']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.home' | translate }}</div>

          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.account' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/rewards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.rewards' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'payment.information' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/loadedtickets']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.loaded.tickets' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.games' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.earn' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.gallery' | translate }}</div>
          <div class="material-icons icon">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.faq' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-icons icon">navigate_next</div>
          </div>
        </a>
        <a class="nav-item" [routerLink]="['/contact']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-icons icon">navigate_next</div>
          </div>
        </a>
        <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-icons icon">navigate_next</div>
          </div>
        </a>
        <a class="nav-item" (click)="logout()">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
